import {
  PrescriptionDetailProps,
  PrescriptionDetails,
} from '../interface/interface';
import RenderProductDescription from './RenderProductDescription';

export const PrescriptionDetail = ({
  label,
  value,
}: PrescriptionDetailProps) => {
  const renderValue = (label: string, value: string) => {
    if (label?.replace(':', '') === PrescriptionDetails.PRODUCT_DETAILS) {
      return <RenderProductDescription description={value} />;
    }

    return value;
  };
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 mb-2">
      <label className="col-span-2 text-sm font-semibold">{label}</label>
      <p className="col-span-3 text-sm text-primary-blue-500 break-words font-regular">
        {renderValue(label, value)}
      </p>
    </div>
  );
};
